import React from 'react'

export class GlassboxAddOn extends React.Component {
  componentDidMount() {
    const botId = this.props.store.config.botId
    const env = window.EXTERNAL_URL + '/api/v1/bots/'
    const lookup = '/mod/glassbox/config'
    const url = env + botId + lookup
    const reportUri = 'reportURI\x3dhttps://report-tf.glassboxcloud.com/glassbox/'
    const cls =
      '/cls_report;maskingMode\x3dwhitelist;recordScrolls\x3dtrue;recordMouseMoves\x3dtrue;idleEventTimeInterval\x3d-1;'

    const getScript = fetch(url)
      .then(response => response.json())
      .then(data => {
        return data
      })

    const verifyScriptType = async () => {
      const data = await getScript
      if (data.setAttribute == true) {
        return new Promise((resolve, reject) => {
          const attributeUrl = reportUri + data.attributeKey + cls
          const s = document.createElement('script')
          s.src = data.glassboxEndpoint
          s.id = data.id
          s.setAttribute(data.attributeType, attributeUrl)
          s.addEventListener('load', resolve)
          s.addEventListener('error', reject)
          document.head.appendChild(s)
        })
      } else if (data.setAttribute == false) {
        return new Promise((resolve, reject) => {
          const s = document.createElement('script')
          s.setAttribute('src', data.glassboxEndpoint)
          s.id = data.id
          s.addEventListener('load', resolve)
          s.addEventListener('error', reject)
          document.head.appendChild(s)
        })
      }
    }

    verifyScriptType()
  }

  render() {
    return null
  }
}
